<template>
<div style="padding: 0 10px">
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span>任务列表</span>
      <div>
        <el-tag style="margin-right: 12px" type="info" effect="plain">空闲</el-tag>
        <el-tag style="margin-right: 12px" type="primary" effect="dark">配货中</el-tag>
        <el-tag style="margin-right: 12px" type="success" effect="dark">配货完成</el-tag>
      </div>
    </div>
    <el-empty description="暂无数据" v-if="!basketList.length"></el-empty>
    <div class="card__div--item" v-else>
      <el-card shadow="hover" v-for="(i,index) in basketList" :class="{
        'default__card': true,
        'primary__card': i.useStatus === 1 && i.allotStatus === 0,
        'success__card': i.useStatus === 1 && i.allotStatus === 1,
      }" :key="index">
        <p style="text-align: left; margin: 8px 0">篮子编号：{{i.basketCode}}</p>
        <p style="text-align: left; margin: 8px 0">发货编号：{{i.deliveryTaskCode}}</p>
        <div style="text-align:left" v-if="i.pkgCodeList">批次包号：<div v-for="(item,index) in i.pkgCodeList" :key="index">{{item}}</div>
        </div>
      </el-card>
    </div>
  </el-card>
</div>
</template>

<script>
import {basketList} from "@/apis/outStock";

export default {
  name: "SmallMultiSowing", // 小件多品播种
  data () {
    return {
      timer: null,
      basketList: [
        // {
        //   basketCode: '',
        //   shipCode: ''
        // }
      ]
    }
  },
  created() {

    this.getSowingData()

  },
  watch: {
    $route: {
      handler: function (newVal) {
        const that = this
        if(newVal.name === 'SmallMultiSowing' || newVal.path === '/outOfStock_smallMultiSowing') {
          // 10秒刷新一次
          that.timer = setInterval(_=> {
            that.getSowingData()
          }, 10000)
        } else {
          clearInterval(that.timer)
          that.timer = null
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getSowingData: function () {
      //
      const that = this
      const _list = []
      basketList().then(({code, data}) => {
        // console.log(code, data)
        if(code === 0) {
          that.basketList = data
        }
      })
    }
  },
  destroyed() {
    clearInterval(this.timer)
    this.timer = null
  }
}
</script>

<style scoped>
.box-card ::v-deep.el-card__header {
  background: #f8f8f8;
}

.box-card {
  margin-bottom: 20px;
}

.clearfix {
  font-size: 14px;
  font-weight: bold;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.clearfix > div {
  padding-left: 40px;
  margin-left: auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  top: 0;
  left: 0;
  height: 24px;
  line-height: 24px;
}
.clearfix > div::before{
  display: block;
  content: '\56fe\4f8b:';
    /* 图例的unicode */
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  margin: auto 0;
  height: 24px;
  line-height: 24px;
}
.card__div--item {
  display: grid;
  grid-template-columns: repeat(5, auto);
  grid-template-rows: auto;
}
.default__card {
  margin: 10px;
  font-size: 14px;
  font-weight: 600;
}
.success__card {
  background: #1bc318;
  color: white;
}
.primary__card {
  background: #40a9ff;
  color: white;
}
</style>